import React from "react";
import Fade from 'react-reveal/Fade';

import Paolo from '../images/paolo_trapu.jpg';

const About = () => {
    return (
    <section id='about'>
      <div className="text">
          <h2>A propos de moi</h2>
          <p>Après mon année de licence Développeur Web je souhaite continuer à développer mes compétences en JS et PHP dans une agence web au sein d’une équipe passionnée.</p>
      </div>
      <Fade clear>
        <img src={Paolo} alt="Paolo Trapu"/>
      </Fade>
    </section>
  );
};

export default About;